"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./utils");

var _constants = require("../../constants");

var _Textarea = _interopRequireDefault(require("./Textarea.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var EMPTY_HTML = '<div><br/></div>';

var escapeText = function escapeText(text) {
  return text.replace(/[&<>"']/g, function (curString) {
    // https://lodash.com/docs#escape
    var entityMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    return entityMap[curString];
  });
};

var Textarea = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var ariaAttributes = _ref.ariaAttributes,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      onKeyUp = _ref.onKeyUp,
      onStructuredTextHover = _ref.onStructuredTextHover,
      placeholder = _ref.placeholder,
      richTextEntry = _ref.richTextEntry,
      structuredText = _ref.structuredText;
  var componentRef = (0, _react.useRef)();
  var textareaRef = (0, _react.useRef)();
  var cursorPositionRef = (0, _react.useRef)(0);
  var cursorPositionOffsetRef = (0, _react.useRef)(0);
  var compositionTrackerRef = (0, _react.useRef)(false);

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      isEmpty = _useState2[0],
      setIsEmpty = _useState2[1];

  var inputQueue = (0, _react.useRef)([]);
  var inputQueuePosition = (0, _react.useRef)(-1);
  (0, _react.useEffect)(function () {
    if (richTextEntry) {
      textareaRef.current.innerHTML = EMPTY_HTML;
    }
  }, [richTextEntry]);
  (0, _react.useEffect)(function () {
    var componentEl = componentRef.current;

    var handleStructuredTextHover = function handleStructuredTextHover(evt) {
      var toElement = evt.toElement || evt.relatedTarget;

      if (toElement && toElement.dataset.structuredtextid && (evt.which === 0 || evt.buttons === 0)) {
        onStructuredTextHover(evt, componentRef.current);
      } else {
        onStructuredTextHover();
      }
    };

    if (richTextEntry) {
      componentEl.addEventListener('mouseout', handleStructuredTextHover);
    }

    return function () {
      if (richTextEntry) {
        componentEl.removeEventListener('mouseout', handleStructuredTextHover);
      }
    };
  }, [onStructuredTextHover, richTextEntry]);
  var resetTrackingRefs = (0, _react.useCallback)(function () {
    cursorPositionRef.current = 0;
    cursorPositionOffsetRef.current = 0;
    compositionTrackerRef.current = false;
  }, []);
  var setTextareaValue = (0, _react.useCallback)(function (textareaValue) {
    var shouldSetCursorPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var trimmedText = textareaValue;
    var isEmptyValue = false;
    var textResp;

    if (richTextEntry) {
      // Safari leaves trailing \n when clearing content editable
      if (trimmedText.length < 1) {
        isEmptyValue = true;
        resetTrackingRefs();
      } else if (trimmedText.length === 1 && trimmedText[trimmedText.length - 1] === '\n') {
        isEmptyValue = true;
        trimmedText = trimmedText.slice(0, -1);
        resetTrackingRefs();
      }

      textareaRef.current.innerHTML = isEmptyValue ? EMPTY_HTML : textareaValue;
      setIsEmpty(isEmptyValue);
      textResp = isEmptyValue ? trimmedText : textareaRef.current.innerText;
    } else {
      textareaRef.current.value = textareaValue;
      textResp = textareaRef.current.value;
    }

    if (shouldSetCursorPosition) {
      (0, _utils.setCursorPosition)(textareaRef.current, cursorPositionRef.current);
    }

    onChange(textResp, cursorPositionRef.current);
  }, [onChange, resetTrackingRefs, richTextEntry]);
  var makeChange = (0, _react.useCallback)(function (value, newCursorPosition) {
    var trackChangeAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'insert';
    var newValue = value;

    if (richTextEntry) {
      if (trackChangeAction === 'insert') {
        inputQueue.current = inputQueue.current.slice(0, inputQueuePosition.current + 1);
        inputQueue.current.push(newValue);
        inputQueuePosition.current = inputQueue.current.length - 1;
      } else if (trackChangeAction === 'update') {
        inputQueue.current[inputQueuePosition.current] = newValue;
      }

      newValue = escapeText(newValue);
      structuredText.forEach(function (structuredItm) {
        newValue = newValue.replace(new RegExp(structuredItm.text, 'g'), "<span class=\"".concat(structuredItm.class, "\" data-structuredtextid=\"").concat(structuredItm.id, "\">").concat(structuredItm.text, "</span>"));
      });
    }

    cursorPositionRef.current = newCursorPosition !== undefined ? newCursorPosition : (0, _utils.getCursorPosition)(textareaRef.current) + cursorPositionOffsetRef.current;
    cursorPositionOffsetRef.current = 0;
    setTextareaValue(newValue);
  }, [richTextEntry, setTextareaValue, structuredText]);
  var handleChange = (0, _react.useCallback)(function (evt) {
    if (richTextEntry) {
      evt.persist();
      var nativeEvent = evt.nativeEvent;
      var inputType = nativeEvent.inputType;
      var changeValue;
      var trackChangeAction = 'ignore';
      var newCursorPosition;

      if (inputType === 'historyUndo') {
        if (inputQueuePosition.current > -1) {
          inputQueuePosition.current--;
          changeValue = inputQueuePosition.current === -1 ? '' : inputQueue.current[inputQueuePosition.current];
          newCursorPosition = changeValue.length;
        }
      } else if (inputType === 'historyRedo') {
        if (inputQueuePosition.current < inputQueue.current.length - 1) {
          var _changeValue;

          inputQueuePosition.current++;
          changeValue = inputQueue.current[inputQueuePosition.current];
          newCursorPosition = (_changeValue = changeValue) === null || _changeValue === void 0 ? void 0 : _changeValue.length;
        }
      } else {
        changeValue = evt.target.innerText;

        if (!inputQueue.current.length || nativeEvent.inputType === 'insertParagraph' || nativeEvent.inputType === 'insertText' && nativeEvent.data === ' ') {
          trackChangeAction = 'insert';
        } else {
          trackChangeAction = 'update';
        }
      }

      if (!compositionTrackerRef.current && changeValue !== undefined) {
        makeChange(changeValue, newCursorPosition, trackChangeAction);
      }
    } else {
      makeChange(evt.target.value);
    }
  }, [makeChange, richTextEntry]);
  var handleKeyDown = (0, _react.useCallback)(function (evt) {
    if (richTextEntry && evt.keyCode === _constants.KEY_CODES.ENTER) {
      if (textareaRef.current.innerText[(0, _utils.getCursorPosition)(textareaRef.current) + 1] === undefined) {
        cursorPositionOffsetRef.current += 1;
      }
    }

    onKeyDown(evt);
  }, [onKeyDown, richTextEntry]);
  var handleKeyUp = (0, _react.useCallback)(function (evt) {
    onKeyUp(evt, cursorPositionRef.current);
  }, [onKeyUp]);
  var handleBlur = (0, _react.useCallback)(function (evt) {
    if (richTextEntry) {
      (0, _utils.clearCursorPosition)(); // Even after blur Safari leaves cursor active
    }

    onBlur(evt);
  }, [onBlur, richTextEntry]);
  var handleCompositionStart = (0, _react.useCallback)(function () {
    compositionTrackerRef.current = true;
  }, []);
  var handleCompositionEnd = (0, _react.useCallback)(function () {
    compositionTrackerRef.current = false;

    if (richTextEntry) {
      makeChange(textareaRef.current.innerText);
    }
  }, [makeChange, richTextEntry]);
  var handleClick = (0, _react.useCallback)(function () {
    cursorPositionRef.current = (0, _utils.getCursorPosition)(textareaRef.current) + cursorPositionOffsetRef.current;
  }, []);
  var handleFocus = (0, _react.useCallback)(function (evt) {
    (0, _utils.setCursorPosition)(textareaRef.current, cursorPositionRef.current);
    onFocus(evt);
  }, [onFocus]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      clearTextareaInput: function clearTextareaInput() {
        resetTrackingRefs();
        setTextareaValue('', false);
        textareaRef.current.blur();
      },
      getCursorPosition: function getCursorPosition() {
        return cursorPositionRef.current = (0, _utils.getCursorPosition)(textareaRef.current);
      },
      setFocus: function setFocus() {
        textareaRef.current.focus();
      },
      setText: function setText(value, newCursorPosition, scrollToEnd) {
        makeChange(value, newCursorPosition);
        onKeyUp({}, newCursorPosition, value);

        if (scrollToEnd) {
          textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
        }
      }
    };
  });

  var attributes = _objectSpread(_objectSpread({}, ariaAttributes), {}, {
    'aria-autocomplete': 'list',
    'aria-multiline': 'true',
    'aria-owns': 'ccx-suggestion-list',
    'aria-placeholder': placeholder,
    role: 'textbox',
    onBlur: handleBlur,
    onClick: handleClick,
    onCompositionStart: handleCompositionStart,
    onCompositionEnd: handleCompositionEnd,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    placeholder: placeholder
  });

  if (richTextEntry) {
    attributes.onInput = handleChange;
  } else {
    attributes.onChange = handleChange;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_Textarea.default.component, {
      'rich-text-entry': richTextEntry,
      'plain-text-entry': !richTextEntry
    }),
    ref: componentRef
  }, richTextEntry ? /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "textarea content-editable".concat(isEmpty && !compositionTrackerRef.current ? ' empty' : ''),
    contentEditable: true
  }, attributes, {
    ref: textareaRef
  })) : /*#__PURE__*/_react.default.createElement("textarea", _extends({
    className: "textarea plain",
    rows: "1"
  }, attributes, {
    ref: textareaRef
  })));
});
Textarea.displayName = 'Textarea';
Textarea.defaultProps = {
  ariaAttributes: {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyUp: function onKeyUp() {},
  onStructuredTextHover: function onStructuredTextHover() {},
  placeholder: '',
  richTextEntry: false,
  structuredText: []
};
Textarea.propTypes = {
  ariaAttributes: _propTypes.default.object,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func.isRequired,
  onFocus: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onKeyUp: _propTypes.default.func,
  onStructuredTextHover: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  richTextEntry: _propTypes.default.bool,
  structuredText: _propTypes.default.array
};
var _default = Textarea;
exports.default = _default;